export default __webpack_public_path__ + "static/media/watch-3.f28d265e.png";